@if (multi == 'contact') {
  <div class="form-control form-select filterOffcanvas__inputlabel">
    <div (mouseleave)="showDropDown = false">
      <button class="drop-toggle btn flat" (click)="showDropdown()">
        @if (checkedList.length<=0) {
          <span class="spancolor">
            Select {{selectedType === "Sent"? "Sent To": selectedType === "Drafts"? "Drafted To": selectedType ===
          "Request"? "Request": "Received From"}}</span>
        }
        @if (checkedList.length>0) {
          <span class="spancolor">{{checkedList.join(', ')}}</span>
        }
      </button>
      @if (showDropDown && list.length>0) {
        <div class="drop-show">
          <div class="usersFilter__branchesField">
            <div class="usersFilter__branchWrappar">
              <img class="usersFilter__searchIcon" src="../../../../assets/Images/user-management/searchIcon.svg" alt="search" />
              <input (input)="handleFilterContact($event)" class="usersFilter__input" placeholder="Search" />
            </div>
          </div>
          @for (item of contactData; track item) {
            <label for="contactdata">
              <app-checkbox id="contactdata" checkboxStatus="{{item.checked}}" (checked)="getSelectedValue($event.event.target.checked, item)"></app-checkbox>
              <span>{{item.connectedCompany?.name}}</span>
            </label>
          }
        </div>
      }
    </div>
  </div>
}



@if (multi == 'multi') {
  <div class="form-control form-select filterOffcanvas__inputlabel">
    <div (mouseleave)="showDropDown = false">
      <button class="drop-toggle btn flat" (click)="showDropdown()">
        @if (checkedMultiList.length<=0) {
          <span class="spancolor">
          Select Document Type</span>
        }
        @if (checkedMultiList.length>0) {
          <span class="spancolor">{{checkedMultiList.join(', ')}}</span>
        }
      </button>
      @if (showDropDown && listData.length>0) {
        <div class="drop-show">
          <div class="usersFilter__branchesField">
            <div class="usersFilter__branchWrappar">
              <img class="usersFilter__searchIcon"
                src="../../../../assets/Images/user-management/searchIcon.svg" alt="search"  />
                <input (input)="handleFilter($event)" class="usersFilter__input" placeholder="Search"/>
              </div>
            </div>
            @for (item of multiListData; track item) {
              <label for="multilistdata">
                <app-checkbox id="multilistdata" checkboxStatus="{{item.checked}}"
                (checked)="getMultiSelectedValue($event.event.target.checked, item)"></app-checkbox>
                <span>{{item.name}}</span>
              </label>
            }
          </div>
        }
      </div>
    </div>
  }
